/* CreateQuestionComponent.js */

"use strict";
//const EventEmitter = require("events").EventEmitter;
//const Renderer = require("./CreateQuestionRenderer");
const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CreateQuestionComponent extends BaseCreateComponent {
    constructor(logger, title, message) {
        super(logger, title || "Create Plan", message, "Enter Network Discovery Plan Name");
    }
}

module.exports = CreateQuestionComponent;
